import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

const navItems = [
  { label: '热门话题', href: '#topics' },
  { label: '最新动态', href: '#updates' },
  { label: '精选推荐', href: '#cards' },
  { label: '联系我们', href: '#contact' },
  { label: '用户评价', href: '#comments' },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header navItems={navItems} />
      <main>
        <Hero />
        <AppSection />
        <RankingSection />
        <ContactSection />
        <FeaturesSection />
        <CarouselSection />
        <UpdatesSection />
        <TopicsSection />
        <IndexSection />
        <CommentsSection />
        <FaqSection />
        <MediaSection />
        <CardsSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}